<template>
  <div>
    <el-dialog
      top="10vh"
      width="510px"
      center
      :title="`「${
        DeleteCardObj.bankCardNumber
          ? DeleteCardObj.bankCardNumber.match(/.{1,4}/g).join(' ')
          : ''
      }」银行卡`"
      :visible="DeleteCardObj.visible"
      @close="HandleCancel"
    >
      <div style="font-weight: 600; font-size: 16px">
        删除银行卡请确认以下状态:
      </div>
      <div style="margin-top: 20px">
        1. 该银行卡目前已禁用 <br />
        2. 该银行卡目前未有处理中收付款订单<br />
        3. 手动卡需要先解绑操作员<br />
        <span
          v-if="
            DeleteCardObj.usernamePath && DeleteCardObj.usernamePath.split('/')
          "
          >4. 删除的卡所属
          <span class="bop"
            ><span>{{ DeleteCardObj.usernamePath.split("/")[1] }}</span></span
          >
          请再次确认</span
        >
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="HandleCancel()"> 取消 </el-button>
        <el-button @click="HandleDelete()" type="danger"> 确认 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import varCommon from "@/utils/varCommon";
import { accountCardDelete } from "@/api/account";

export default {
  mixins: [mainCommon],
  props: ["DeleteCardObj"],
  methods: {
    HandleDelete() {
      this.$confirm(
        `确定要删除「${
          this.DeleteCardObj.bankCardNumber
            ? this.DeleteCardObj.bankCardNumber.match(/.{1,4}/g).join(" ")
            : ""
        }」银行卡？`,
        varCommon.message.warning,
        {
          confirmButtonText: varCommon.message.confirm,
          cancelButtonText: varCommon.message.cancel,
          type: "error",
        }
      )
        .then(() => {
          accountCardDelete(this.DeleteCardObj.id).then((res) => {
            this.$notify.success(res.message);
            this.HandleCancel();
            this.$emit("HandleGetList");
          });
        })
        .catch(() => {});
    },
    HandleCancel() {
      this.$emit("update:delete-card-obj", {});
    },
  },
};
</script>

<style lang="scss" scoped>
.bop {
  font-size: 28px;
  color: #ff0000;
  letter-spacing: 2px;
  text-shadow: 0 0.1em 20px #c65757, 0.05em -0.03em 0 #933232,
    0.05em 0.005em 0 #933232, 0em 0.08em 0 #933232, 0.05em 0.08em 0 #933232,
    0px -0.03em 0 #933232, -0.03em -0.03em 0 #933232, -0.03em 0.08em 0 #933232,
    -0.03em 0 0 #933232;
  span {
    transform: scale(0.9);
    display: inline-block;
  }
  span:first-child {
    animation: bop 1s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards infinite
      alternate;
  }
}

@keyframes bop {
  0% {
    transform: scale(0.9);
  }
  50%,
  100% {
    transform: scale(1);
  }
}
</style>


// WEBPACK FOOTER //
// src/views/account/bank/DeleteCard.vue